import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { z } from 'zod'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const NetworkPage = lazy(() => import('@/pages/infra/NetworkPage'))

const networkSearchSchema = z.object({
  cluster: z.string().optional(),
})

export const Route = createFileRoute('/infra/network/')({
  validateSearch: networkSearchSchema,
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <NetworkPage />
    </Suspense>
  ),
})
